import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Barcode"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-barcode',
    templateUrl: './icon-barcode.component.html',
    styleUrls: ['./icon-barcode.component.scss'],
    standalone: false
})
export class IconBarcodeComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
